<template>
    <div>
        <el-dialog title="业务咨询" :visible.sync="visible" width="300PX" @close="handleDialogClose">
            <div class="dialog-content">
                <el-form :model="form" ref="dialogForm" label-width="0PX" :rules="rules">
                    <el-form-item class="half-width" prop="name">
                        <el-input v-model="form.name" placeholder="请输入公司名称"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="email">
                        <el-input v-model="form.email" placeholder="请输入公司邮箱"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width date" prop="appointmentTime">
                        <!-- 使用 Element UI 日期选择器组件，适配移动端 -->
                        <el-date-picker v-model="form.appointmentTime" type="date" placeholder="请选择预约时间"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd" popper-class="mobile-date-picker"
                            style="width: 100%;" :editable="false" :clearable="false" />
                    </el-form-item>
                    <el-form-item class="half-width" prop="address">
                        <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="contacts">
                        <el-input v-model="form.contacts" placeholder="请输入联系人"></el-input>
                    </el-form-item>
                    <el-form-item class="half-width" prop="phone">
                        <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item class="full-width spec" prop="demand" style="margin-top: 10px;">
                        <el-input v-model="form.demand" type="textarea" placeholder="请输入您的需求"></el-input>
                    </el-form-item>
                    <el-form-item prop="agreement" style="margin-top: 15PX;">
                        <el-checkbox v-model="form.agreement" class="agreement-checkbox">
                            <span class="txt_check">
                                勾选表示：您同意华软及其授权的合作伙伴通过填写的联系方式联系您，且数据仅用于与您沟通。
                            </span>
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <!-- <el-button @click="closeDialog">取消</el-button> -->
                    <el-button type="primary" :disabled="!form.agreement" @click="handleSubmit">
                        立即咨询
                    </el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 新增：提交成功提示弹窗 -->
        <!-- <el-dialog :visible.sync="dialogVisible" width="500PX" class="consult-dialog2" :show-close="false" center>
            <div class="dialog-content2" style="text-align:center;">
                <div class="icon" style="font-size:48PX;color:#67C23A;margin-bottom:16PX;">
                    <i class="el-icon-success"></i>
                </div>
                <p>信息已提交，请耐心等待...</p>
                <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>

<script>
import { consultationLogAdd } from "@/api/log.js";
export default {
    name: 'ConsultDialog',
    props: {
        visible: {
            type: Boolean,
            required: true,
        },

    },
    data() {
        return {

            form: {
                name: '',
                email: '',
                appointmentTime: '',
                address: '',
                contacts: '',
                phone: '',
                demand: '',
                agreement: false,
            },
            // 新增：表单校验规则
            rules: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入公司邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                ],
                appointmentTime: [
                    { required: true, message: '请输入预约时间', trigger: 'change' }
                ],
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],
                demand: [
                    { required: true, message: '请输入您的需求', trigger: 'blur' }
                ],
                agreement: [
                    {
                        required: true, type: 'boolean', validator: (rule, value, callback) => {
                            if (!value) {
                                callback(new Error('请勾选同意协议'));
                            } else {
                                callback();
                            }
                        }, trigger: 'change'
                    }
                ]
            },
            dialogVisible: false, // 新增：控制提交成功弹窗
        };
    },
    methods: {
        closeDialog() {
            this.$emit('close');
        },
        handleDialogClose() {
            // 关闭弹窗时，通知父组件将visible设为false
            this.$emit('update:visible', false);
            this.$emit('close');
        },
        handleSubmit() {
            if (!this.form.agreement) return;
            this.$refs.dialogForm.validate((valid) => {
                if (valid) {
                    // 格式化 appointmentTime 为 YYYY-MM-DD
                    if (this.form.appointmentTime) {
                        const d = new Date(this.form.appointmentTime);
                        const yyyy = d.getFullYear();
                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                        const dd = String(d.getDate()).padStart(2, '0');
                        this.form.appointmentTime = `${yyyy}-${mm}-${dd}`;
                    }

                    // this.dialogVisible = true; // 显示成功弹窗
                    // this.visible = false; // 主弹窗关闭
                    const { result } = consultationLogAdd(this.form);
                    this.$emit('submit');
                } else {
                    console.error('表单验证失败');
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
/* 将背景图应用到整个弹窗 */
::v-deep .el-dialog {
    background-color: #f3f6f8;
    // background-image: url('../../assets/home/ziXunDiag.png');
    // background: linear-gradient(156deg, #E9EFF6 5%, rgba(233, 239, 246, 0.1) 132%);
    background-size: cover;
    background-position: center;
    /* 可选：添加半透明遮罩提升内容可读性 */
    position: relative;
    /* 保证内容层级正常 */
    z-index: auto;
}

::v-deep .el-input__inner {
    border: none;
}

::v-deep .el-dialog__body {
    height: 513PX;
}


::v-deep .el-dialog__title {
    font-size: 14PX;
}

/* 可选：为内容添加半透明背景提升可读性 */
.dialog-content {
    // background: rgba(255,255,255,0.85);
    padding: 0PX 16PX;
    // padding-right: 240PX;
    position: static;
    z-index: auto;
}

/* 新增：提高弹窗z-index，确保显示在最上面 */
//  .el-dialog__wrapper {
//     z-index: 3000 !important;
// }

.dialog-footer {
    display: flex;
    justify-content: flex-start;
    margin-top: 12PX;

    .el-button {
        width: 100%;
        height: 32PX;
        line-height: 9PX;
        font-size: 12PX;
    }
}

/* 新增表单布局样式 */
.half-width {
    width: 100%;
    display: inline-block;
    margin-right: 24PX;
    vertical-align: top;
    margin-bottom: 12PX;
}

.full-width {
    // width: 98%;
    display: block;
    // margin: 0 auto;
}

/* 让最后一行不换行 */
.half-width:nth-child(2n) {
    margin-right: 0;
}

.header {
    z-index: 100;
}




::v-deep .el-dialog__header {
    padding: 16PX;
    padding-bottom: 12PX;
    opacity: 1;

    font-family: PingFang SC;
    font-size: 18PX;
    font-weight: bold;
    // line-height: 32PX;
    letter-spacing: 0PX;

    color: #3D3D3D;
}

::v-deep .el-input__inner {
    height: 32PX;
    font-size: 12PX;
}

::v-deep .el-textarea__inner {
    height: 60PX;
    font-size: 12PX;
}



::v-deep .el-checkbox__label {
    white-space: normal;
    font-size: 10PX;
    padding-left: 6PX;
    width: 99%;

    span {
        display: inline-block;
        line-height: 18PX;
    }
}

::v-deep .el-checkbox__input {}

::v-deep .el-checkbox__inner {
    width: 12PX;
    height: 12PX;
    top: 2PX;
}


::v-deep .el-form-item__error {
    font-size: 10PX;
}

::v-deep .el-input__inner {
    padding-left: 8PX;
}

.txt_check {}

::v-deep .el-icon-close:before {
    display: inline-block;
    width: 13PX;
    // height: 13PX;
    font-size: 13PX;
    // margin-top: 15PX;
    // margin-right: 10PX;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner::after {

    height: 8PX;
    left: 3PX;
    width: 3PX;
    top: -1PX;
}

::v-deep .el-dialog__headerbtn {
    top: 16px;
}

.agreement-checkbox {
    display: flex;
    align-items: flex-start;

    .el-checkbox__input {
        margin-top: 0;
        margin-right: 8PX;
    }

    .el-checkbox__label {
        padding-left: 0;
        width: auto;

        span.txt_check {
            color: #1E242A;
            opacity: 0.6;
            font-size: 10PX;
            line-height: 18PX;
            display: inline-block;
            vertical-align: middle;
            word-break: break-all;
        }
    }
}

::v-deep .el-input__prefix {
    display: none;
}

.spec {
::v-deep .el-textarea__inner {
    padding: 5px 8px !important;
}
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 8px !important;
}

</style>
